import { useCallback } from 'react';

export const useInitXpointNativeSDK = () => {
    return useCallback(async () => {
        return {};
    }, []);
};
